import { take } from "../util/takePayload";
export const fromGql = (gqlItem) => take(gqlItem, 'variant', 'src');
export const fromGqlCollection = (gqlItems) => (gqlItems ? gqlItems.map(fromGql) : []);
//# sourceMappingURL=AnnounceImageVariant.js.map